function Switch({ name, value, onChange }) {
  const checked = value === "S";

  const handleClick = () => {
    onChange({
      target: {
        name,
        value: checked ? "N" : "S",
      },
    });
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`nobutton relative inline-flex h-5 w-9 items-center rounded-full p-0 transition-colors ${
        checked ? "bg-default" : "bg-gray-400"
      }`}
    >
      <span
        className={`inline-block h-4 w-4 rounded-full bg-white transition-transform ${
          checked ? "translate-x-4" : "translate-x-0.5"
        }`}
      />
    </button>
  );
}

export default Switch;